import { render } from "./BulkUpdata.vue?vue&type=template&id=4db02a79"
import script from "./BulkUpdata.vue?vue&type=script&lang=js"
export * from "./BulkUpdata.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__